import { useEffect, useRef, useState } from "react";
import { Box, Icon, Search } from "@storyofams/react-ui";
import { useRouter } from "next/router";
import styled from "styled-components";
import { Cross, NhSearch } from "~components/common/Icons";

export const StyledInput = styled(Box)`
  appearance: none;
  display: inline-block;
  background-color: white;
  border-color: #e2dfdf;
  border-width: 1px;
  border-style: solid;
  transition: border-color 0.18s ease-in-out, background-color 0.18s ease-in-out;
  text-decoration: none;

  &::placeholder {
    color: #767473};
    font-size: 18px
    text-overflow: ellipsis;
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
`;
export const RecipesSearchBar = () => {
  const router = useRouter();
  const [searchValue, setSearchValue] = useState<string>("");
  const setStateId = useRef<any>();
  const onSearchStateChange = (nextSearchState) => {
    clearTimeout(setStateId.current);
    setSearchValue(nextSearchState);
    setStateId.current = setTimeout(() => {
      const route = {
        query: { ...router.query, q: nextSearchState },
      };
      router.push(route, undefined, { shallow: true });
    }, 400);
  };
  useEffect(() => {
    if (router.isReady && router?.query?.q) {
      setSearchValue(String(router.query.q));
    }
  }, [router.isReady, router?.query?.q]);
  return (
    <form
      noValidate
      action=""
      role="search"
      onSubmit={(e) => {
        e.preventDefault();
        return false;
      }}
    >
      <Box position="relative" mb={2}>
        <StyledInput
          as="input"
          px={2}
          py={1.5}
          pr={5}
          fontSize={2}
          height={["42px", "53px"]}
          width={"100%"}
          color="black"
          borderRadius="6px"
          type="search"
          name="search"
          placeholder="Zoek binnen recepten"
          value={searchValue}
          onChange={(e: any) => {
            onSearchStateChange(e.target.value);
          }}
        />

        <Icon
          display="flex"
          alignItems="center"
          position="absolute"
          right={1.5}
          top={0}
          bottom={0}
          color="grey800"
          fontSize={[2, 2.5]}
          as="button"
          type="button"
          icon={searchValue ? Cross : NhSearch}
          onClick={() => {
            if (searchValue) {
              const route = {
                query: { ...router.query, q: "" },
              };
              router.push(route, undefined, { shallow: true });
              setSearchValue("");
            }
          }}
        />
      </Box>
    </form>
  );
};
